// extracted by mini-css-extract-plugin
module.exports = {"btnRoomCode":"styles_btnRoomCode__2FSnn"};